import HeaderBar from 'pages/quoteLinkPage/HeaderBar';
import style from '../../sass/style.module.scss';
import ServerRenderContent from '../../pages/quoteLinkPage/ServerRenderContent';

export default function QuoteLinkHeader(props) {
  const {
    quoteTitle,
    brandPhoneNumber,
    openingTimes,
    websiteUrl,
    brandLogo,
    openPhoneDetails,
    brandTheme,
  } = props;

  let headerBgStyle = {
    backgroundImage: `url(/self-service/static/media/header.48a2f52c.jpg)`,
  };
  let headerClassNames = style.overviewPageHeader;
  const brandThemeObj = JSON.parse(brandTheme.replace(/'/g, '"'));

  if (brandThemeObj.headerImage) {
    headerBgStyle = {
      backgroundImage: `url(/api/v1.10/content/${brandThemeObj.headerImage})`,
    };
    headerClassNames = 'bg-cover bg-no-repeat bg-right-top';
  }

  return (
    <header
      style={headerBgStyle}
      className={`${headerClassNames} h-[50vh] flex flex-col justify-between lg:h-[45vh] 2xl:h-[50vh]`}
    >
      <div className="pl-7 pb-7 text-white gradient-overlay h-full flex items-end">
        <div>
          <div className="font-medium text-4xl xs:text-5xl lg:text-[75px]">
            {quoteTitle && <ServerRenderContent html={quoteTitle} />}
          </div>
        </div>
      </div>
      <HeaderBar
        brandPhoneNumber={brandPhoneNumber}
        openingTimes={openingTimes}
        websiteUrl={websiteUrl}
        brandLogo={brandLogo}
        openPhoneDetails={openPhoneDetails}
      />
    </header>
  );
}
